import { useFieldArray, useFormState } from 'react-hook-form';

import useForm from 'utils/hooks/useForm';

const useSiteSpecificSpacesController = ({ values, onSubmit }) => {
  const { control, reset, handleSubmit, getValues } = useForm({
    defaultValues: {
      siteSpecificSpaces: values
    }
  });
  const {
    fields: spaces,
    append,
    update,
    remove
  } = useFieldArray({
    control,
    name: 'siteSpecificSpaces'
  });

  const { isDirty } = useFormState({ control });

  return {
    spaces,
    control,
    add: append,
    edit: update,
    remove,
    reset: (newSpaces) =>
      reset({
        siteSpecificSpaces: newSpaces
      }),
    getValues: () => getValues().siteSpecificSpaces,
    onSubmit: handleSubmit((values) => onSubmit(values.siteSpecificSpaces, isDirty))
  };
};

export default useSiteSpecificSpacesController;
